import React, { useMemo, useState } from 'react';
import { const_var, params } from '../../../redux/reducers/reducer';
import WallNameTemplete from './WallNameTemplete';

const WallName = () => {

    ///////////// front //////////////
    const frontPosState = useMemo(() => {
        let offset = false;

        if (params.leanF_p_w < 10) {
            if ((params.leanF_p_pos - params.leanF_p_d / 2 - 2.5 < 0.8 && params.leanF_p_pos - params.leanF_p_d / 2 - 2.5 > -1.8) ||
                (params.leanF_p_pos + params.leanF_p_d / 2 + 2.5 > -0.8 && params.leanF_p_pos + params.leanF_p_d / 2 + 2.5 < 1.8)) {
                offset = true;
            }
        }
        
        if (params.add_storage_check_front && params.leanF_p_w < 12) {
            if (params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front) + 1.5 > -0.8 && params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front) + 1.5 < 1.8) {
                offset = true;
            }
        }

        return offset;
        
    }, [params.leanF_p_d, params.p_w, params.leanF_p_w, params.leanF_p_pos, params.add_storage_check_front, params.add_storage_front])

    ///////////// back //////////////
    const backPosState = useMemo(() => {
        let offset = false;

        if (params.leanB_p_w < 10) {
            if ((params.leanB_p_pos - params.leanB_p_d / 2 - 2.5 < 0.7 && params.leanB_p_pos - params.leanB_p_d / 2 - 2.5 > -1.6) ||
                (params.leanB_p_pos + params.leanB_p_d / 2 + 2.5 > -0.7 && params.leanB_p_pos + params.leanB_p_d / 2 + 2.5 < 1.6)) {
                offset = true;
            }
        }

        if (params.add_storage_check_back && params.leanB_p_w < 12) {
            if (params.leanB_p_pos - params.leanB_p_d / 2 + parseInt(params.add_storage_back) + 1.5 > -0.7 && params.leanB_p_pos - params.leanB_p_d / 2 + parseInt(params.add_storage_back) + 1.5 < 1.6) {
                offset = true;
            }
        } 

        return offset;
        
    }, [params.leanB_p_d, params.p_w, params.leanB_p_w, params.leanB_p_pos, params.add_storage_check_back, params.add_storage_back])
   
    ///////////// left //////////////
    const leftPosState = useMemo(() => {
        let offset = false;
        
        if (params.lean_p_w < 10) {
            if ((params.lean_p_pos + params.lean_p_d / 2 + 2.5 > -0.6 && params.lean_p_pos + params.lean_p_d / 2 + 2.5 < 1.6) ||
                (params.lean_p_pos - params.lean_p_d / 2 - 2.5 < 0.6 && params.lean_p_pos - params.lean_p_d / 2 - 2.5 > -1.6)) {
                offset = true;
            }
        }

        if (params.add_storage_check && params.lean_p_w < 12) {
            if (params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage) + 1.5 > -0.6 && params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage) + 1.5 < 1.6) {
                offset = true;
            }
        }

        return offset;
        
    }, [params.lean_p_d, params.p_d, params.lean_p_w, params.lean_p_pos, params.add_storage_check, params.add_storage ])

    ///////////// right //////////////
    const rightPosState = useMemo(() => {
        let offset = false;
        
        if (params.leanR_p_w < 10) {
            if ((params.leanR_p_pos + params.leanR_p_d / 2 + 2.5 > -0.8 && params.leanR_p_pos + params.leanR_p_d / 2 + 2.5 < 1.6) ||
                (params.leanR_p_pos - params.leanR_p_d / 2 - 2.5 < 0.8 && params.leanR_p_pos - params.leanR_p_d / 2 - 2.5 > -1.6)) {
                offset = true;
            }
        }

        if (params.add_storage_check_right && params.leanR_p_w < 12) {
            if (params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right) + 1.5 > -0.8 && params.leanR_p_pos - params.leanR_p_d / 2 + parseInt(params.add_storage_right) + 1.5 < 1.6) {
                offset = true;
            }
        }

        return offset;
        
    }, [params.leanR_p_d, params.p_d, params.leanR_p_w, params.leanR_p_pos, params.add_storage_check_right, params.add_storage_right])
    
    ///////////// front wall storage //////////////
    const frontStoragePosState = useMemo(() => {
        let offset = false;

        if(params.p_f_w !== 'Close') {
            if(params.cB_addStorage_check_left) {
                if(params.leanF_p_w < 10){
                    if((params.leanF_p_pos - params.leanF_p_d / 2 - 2.5 < params.p_w / -2 + parseInt(params.cB_addStorage_left) / 2 + 0.005 + 2.5 && params.leanF_p_pos - params.leanF_p_d / 2 - 2.5 > params.p_w / -2 + parseInt(params.cB_addStorage_left) / 2 + 0.005 - 3.5) ||
                        (params.leanF_p_pos + params.leanF_p_d / 2 + 2.5 > params.p_w / -2 + parseInt(params.cB_addStorage_left) / 2 + 0.005 - 2.5 && params.leanF_p_pos + params.leanF_p_d / 2 + 2.5 < params.p_w / -2 + parseInt(params.cB_addStorage_left) / 2 + 0.005 + 3.5)) {
                        offset = true;
                    }
                }

                if(params.add_storage_check_front && params.leanF_p_w < 12){
                    if(params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front) + 1.5 > params.p_w / -2 + parseInt(params.cB_addStorage_left) / 2 + 0.005 - 2.5 && params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front) + 1.5 < params.p_w / -2 + (parseInt(params.cB_addStorage_left)/2) + 0.005 + 3.5) {
                        offset = true;
                    }
                }  
            } else if(params.cB_addStorage_check_right){
                if(params.leanF_p_w < 10){
                    if((params.leanF_p_pos - params.leanF_p_d / 2 - 2.5 < -(params.p_w / -2 + parseInt(params.cB_addStorage_right) / 2 + 0.005 - 2.5) && params.leanF_p_pos - params.leanF_p_d / 2 - 2.5 > -(params.p_w / -2 + parseInt(params.cB_addStorage_right) / 2 + 0.005 + 3.5)) ||
                        (params.leanF_p_pos + params.leanF_p_d / 2 + 2.5 > -(params.p_w / -2 + parseInt(params.cB_addStorage_right) / 2 + 0.005 + 2.5) && params.leanF_p_pos + params.leanF_p_d / 2 + 2.5 < -(params.p_w / -2 + parseInt(params.cB_addStorage_right) / 2 + 0.005 - 3.5))) {
                        offset = true;
                    }
                }
                if(params.add_storage_check_front && params.leanF_p_w < 12){
                    if(params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front) + 1.5 > -(params.p_w / -2 + parseInt(params.cB_addStorage_right) / 2 + 0.005 + 2.5) && params.leanF_p_pos - params.leanF_p_d / 2 + parseInt(params.add_storage_front) + 1.5 < -(params.p_w / -2 + parseInt(params.cB_addStorage_right) / 2 + 0.005 - 3.5) ) {
                        offset = true;
                    }
                } 
            }
        }
        
        return offset;
        
    }, [params.leanF_p_d, params.p_w, params.leanF_p_w, params.leanF_p_pos, params.add_storage_check_front, params.add_storage_front, params.cB_addStorage_check_left, params.p_f_w, params.cB_addStorage_left, params.cB_addStorage_check_right, params.cB_addStorage_right])

    ///////////// back wall storage //////////////
    const backStoragePosState = useMemo(() => {
        let offset = false;

        if(params.p_b_w !== 'Close') {
            if(params.cB_addStorage_check_left) {
                if(params.leanB_p_w < 10){
                    if((params.leanB_p_pos - params.leanB_p_d / 2 - 2.5 < params.p_w / -2 + parseInt(params.cB_addStorage_left) / 2 + 0.005 + 2.5 && params.leanB_p_pos - params.leanB_p_d / 2 - 2.5 > params.p_w / -2 + parseInt(params.cB_addStorage_left) / 2 + 0.005 - 3.5) ||
                        (params.leanB_p_pos + params.leanB_p_d / 2 + 2.5 > params.p_w / -2 + parseInt(params.cB_addStorage_left) / 2 + 0.005 - 2.5 && params.leanB_p_pos + params.leanB_p_d / 2 + 2.5 < params.p_w / -2 + parseInt(params.cB_addStorage_left) / 2 + 0.005 + 3.5)) {
                        offset = true;
                    }
                }
                if(params.add_storage_check_back && params.leanB_p_w < 12){
                    if(params.leanB_p_pos - params.leanB_p_d / 2 + parseInt(params.add_storage_front) + 1.5 > params.p_w / -2 + parseInt(params.cB_addStorage_left) / 2 + 0.005 - 2.5 && params.leanB_p_pos - params.leanB_p_d / 2 + parseInt(params.add_storage_front) + 1.5 < params.p_w / -2 + parseInt(params.cB_addStorage_left) / 2 + 0.005 + 3.5) {
                        offset = true;
                    }
                }  
            } else if(params.cB_addStorage_check_right){
                if(params.leanB_p_w < 10){
                    if((params.leanB_p_pos - params.leanB_p_d / 2 - 2.5 < -(params.p_w / -2 + parseInt(params.cB_addStorage_right) / 2 + 0.005 - 2.5) && params.leanB_p_pos - params.leanB_p_d / 2 - 2.5 > -(params.p_w / -2 + parseInt(params.cB_addStorage_right) / 2 + 0.005 + 3.5)) ||
                        (params.leanB_p_pos + params.leanB_p_d / 2 + 2.5 > -(params.p_w / -2 + parseInt(params.cB_addStorage_right) / 2 + 0.005 + 2.5) && params.leanB_p_pos + params.leanB_p_d / 2 + 2.5 < -(params.p_w / -2 + parseInt(params.cB_addStorage_right) / 2 + 0.005 - 3.5))) {
                        offset = true;
                    }
                }
                if(params.add_storage_check_back && params.leanB_p_w < 12){
                    if(params.leanB_p_pos - params.leanB_p_d / 2 + parseInt(params.add_storage_back) + 1.5 > -(params.p_w / -2 + parseInt(params.cB_addStorage_right) / 2 + 0.005 + 2.5) && params.leanB_p_pos - params.leanB_p_d / 2 + parseInt(params.add_storage_back) + 1.5 < -(params.p_w / -2 + parseInt(params.cB_addStorage_right) / 2 + 0.005 - 3.5) ) {
                        offset = true;
                    }
                } 
            }
        }
        
        return offset;
        
    }, [params.leanB_p_d, params.p_w, params.leanB_p_w, params.leanB_p_pos, params.add_storage_check_back, params.add_storage_back, params.cB_addStorage_check_left, params.p_b_w, params.cB_addStorage_left, params.cB_addStorage_check_right, params.cB_addStorage_right])
    
    const leftStoragePosState = useMemo(() => {
        let offset = false;
        
        if((parseInt(params.cB_addStorage_left)) === params.p_w - 1) {
            offset = true;
        }
        
        return offset;
    }, [params.cB_addStorage_left, params.p_w])
    
    const rightStoragePosState = useMemo(() => {
        let offset = false;
        
        if((parseInt(params.cB_addStorage_right)) === params.p_w - 1) {
            offset = true;
        }
        
        return offset;
    }, [params.cB_addStorage_right, params.p_w])

    
    if (!const_var.callMesure) return null;

    // const wallTemplates = [
    //     { position: [frontPosState, heightOffset, params.p_d / 2 + 1], rotation: [0, 0, 0], value: 'Front' },
    //     { position: [backPosOffset, heightOffset, -(params.p_d / 2 + 1)], rotation: [0, Math.PI, 0], value: 'Back' },
    //     { position: [-(params.p_w / 2 + 1), heightOffset, leftPosOffset], rotation: [0, -Math.PI / 2, 0], value: 'Left' },
    //     { position: [params.p_w / 2 + 1, heightOffset, rightPosOffset], rotation: [0, Math.PI / 2, 0], value: 'Right' }
    // ];

    let positionFX = 0;
    let positionBX = 0;
    let positionFZ = params.p_d / 2 + (frontPosState ? -0.5 : 1);
    let positionBZ = params.p_d / 2 + (backPosState ? -0.5 : 1);
    let wall_nameF = 'Front';
    let wall_nameB = 'Back';
    let slopeAngleValueF = frontPosState ? 0 : 60;
    let slopeAngleValueB = backPosState ? 0 : 60;
    let heightOffsetF = frontPosState ? 0.7 : 0;
    let heightOffsetB = backPosState ? 0.7 : 0;

    if(params.cB_addStorage_check_left && params.p_f_w != "Close"){
        positionFZ = params.p_d / 2 + (frontStoragePosState ? -0.5 : 1);
        positionFX = params.p_w / -2 + (parseInt(params.cB_addStorage_left)/2) + 0.005 ;
        wall_nameF = "Left Storage Front";
        slopeAngleValueF = frontStoragePosState ? 0 : 60
        heightOffsetF = frontStoragePosState ? 0.7 : 0  
    }

    if(params.cB_addStorage_check_left && params.p_b_w != "Close"){
        positionBZ = params.p_d / 2 + (backStoragePosState ? -0.5 : 1);
        positionBX = params.p_w / -2 + (parseInt(params.cB_addStorage_left)/2) + 0.005 ; 
        wall_nameB = "Left Storage Back";  
        slopeAngleValueB = backStoragePosState ? 0 : 60
        heightOffsetB = backStoragePosState ? 0.7 : 0 
    }

    if(params.cB_addStorage_check_right && params.p_f_w != "Close"){
        positionFZ = params.p_d / 2 + (frontStoragePosState ? -0.5 : 1);
        positionFX = -(params.p_w / -2 + (parseInt(params.cB_addStorage_right)/2) + 0.005) ;
        wall_nameF = "Right Storage Front" ; 
        slopeAngleValueF = frontStoragePosState ? 0 : 60
        heightOffsetF = frontStoragePosState ? 0.7 : 0
    }

    if(params.cB_addStorage_check_right && params.p_b_w != "Close"){
        positionBZ = params.p_d / 2 + (backStoragePosState ? -0.5 : 1);
        positionBX = -(params.p_w / -2 + (parseInt(params.cB_addStorage_right)/2) + 0.005) ;
        wall_nameB = "Right Storage Back" ; 
        slopeAngleValueB = backStoragePosState ? 0 : 60
        heightOffsetB = backStoragePosState ? 0.7 : 0 
    }

    let wallTemplates = [
        { position: [positionFX, heightOffsetF, positionFZ], rotation: [0, 0, 0], slopeAngle: slopeAngleValueF, value: wall_nameF },
        { position: [positionBX, heightOffsetB, - positionBZ], rotation: [0, Math.PI, 0], slopeAngle: slopeAngleValueB, value: wall_nameB },
        { position: [-(params.p_w / 2 + (leftPosState ? -0.5 : 1)), leftPosState ? 0.7 : 0, 0], rotation: [0, -Math.PI / 2, 0], slopeAngle: (leftPosState ? 0 : 60), value: 'Left' },
        { position: [params.p_w / 2 + (rightPosState ? -0.5 : 1), rightPosState ? 0.7 : 0, 0], rotation: [0, Math.PI / 2, 0], slopeAngle: (rightPosState ? 0 : 60), value: 'Right' }
    ];

    if(params.p_u_c) {
        if (params.endStoragePositionZ !== 0) {
            const backStorage = {
                // position: [0, 0, (params.endStoragePositionZ!=0)?(params.p_d / -2 + parseInt(params.p_u_t) + Math.round(params.endStoragePositionZ)+ 0.01):(params.p_d / -2 + parseInt(params.p_u_t) + 0.01)],
                position: [0, 0, (params.endStoragePositionZ!=0)?(params.p_d / -2  + Math.round(params.endStoragePositionZ)+ 0.01):(params.p_d / -2 + 0.01)],
                rotation: [0, Math.PI, 0],
                value: "Back Storage Back",
                slopeAngle : 60
            };
            wallTemplates = [...wallTemplates, backStorage];
        }
        if (params.endStoragePositionZ !== params.p_d - parseInt(params.p_u_t)) {
            const backStorage = {
                position: [0, 0, (params.p_d / -2  + parseInt(params.p_u_t) + params.endStoragePositionZ + 0.01)],
                rotation: [0, 0, 0],
                value: "Back Storage Front",
                slopeAngle : 60
            };
            wallTemplates = [...wallTemplates, backStorage];
        }
    }

    if (params.cB_addStorage_check_left) {
        const leftStorage = {
            position: [(params.p_w / -2 + parseInt(params.cB_addStorage_left) + 0.005 + (leftStoragePosState ? -0.5 : 0)), leftStoragePosState ? 0.7 : 0, 0],
            rotation: [0, Math.PI / 2, 0],
            value: "Left Storage Side",
            slopeAngle: (leftStoragePosState ? 0 : 60)
        };
        wallTemplates = [...wallTemplates, leftStorage];
    }

    if (params.cB_addStorage_check_right) {
        const rightStorage = {
            position: [-(params.p_w / -2 + parseInt(params.cB_addStorage_right) + 0.005 + (rightStoragePosState ? -0.5 : 0)), rightStoragePosState ? 0.7 : 0, 0],
            rotation: [0, -Math.PI / 2, 0],
            value: "Right Storage Side",
            slopeAngle: (rightStoragePosState ? 0 : 60)
        };
        wallTemplates = [...wallTemplates, rightStorage];
    }

    

    return (
        <>
            {wallTemplates.map((template, index) => (
                <WallNameTemplete
                    key={index}
                    position={template.position}
                    rotation={template.rotation}
                    value={template.value}
                    slopeAngle={template.slopeAngle}
                />
            ))}
        </>
    );
};

export default WallName;
